import React from 'react';
import type { CSS } from '@components-shared/src/stitches';
import { styled } from '@components-shared/src/stitches';
import { ErrorMessage } from '../alerts';
import { inputBreakpointStyles, inputDefaultStyles, TextInputContainer } from '../inputStyles';

type TextInputProps = {
  hasError?: boolean;
  isModal?: boolean;
  errorMsg?: string;
  containerStyles?: CSS;
  inputStyles?: CSS;
  type?: string;
  errorStyles?: CSS;
  responsive?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

/**
 * @deprecated Use `Input` instead.
 */
export const DeprecatedTextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      hasError,
      isModal,
      errorMsg,
      containerStyles,
      inputStyles,
      errorStyles,
      type,
      responsive = false,
      ...props
    },
    forwardedRef,
  ) => {
    return (
      <TextInputContainer
        isModal={isModal}
        css={{ ...containerStyles, ...(responsive ? { width: '100%' } : undefined) }}
      >
        <Input
          type={type}
          hasError={hasError}
          ref={forwardedRef}
          isModal={isModal}
          css={{ ...inputStyles, ...(responsive ? { width: '100%' } : undefined) }}
          {...props}
        />
        {hasError && <ErrorMessage css={errorStyles}>{errorMsg}</ErrorMessage>}
      </TextInputContainer>
    );
  },
);

DeprecatedTextInput.displayName = 'TextInput';

const Input = styled('input', {
  ...inputDefaultStyles,
  ...inputBreakpointStyles,
  variants: {
    ...inputDefaultStyles.variants,
    ...inputBreakpointStyles.variants,
  },
});
